// eslint-disable-next-line import/no-extraneous-dependencies
import validate from 'validate.js';

export default (element, data) => {
  const { success, zapierURL } = data;
  const form = element.querySelector('[data-contact-form]');
  const webhookURL = zapierURL || null;

  if (!webhookURL) {
    // eslint-disable-next-line no-console
    console.error('Zapier URL needed!');
    return;
  }

  const constraints = {
    subject: {
      presence: { allowEmpty: false },
    },
    name: {
      presence: { allowEmpty: false },
    },
    email: {
      presence: { allowEmpty: false },
      format: {
        pattern:
          // eslint-disable-next-line max-len
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        message: ``,
      },
    },
    body: {
      presence: { allowEmpty: false },
    },
  };

  const postData = async (url = '', obj = {}) => {
    await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Accept: 'application/json',
      },
      body: JSON.stringify(obj),
    });
  };

  const showError = (el, err) => {
    const [firstError] = err; // eslint-disable-next-line no-param-reassign
    el.value = ''; // eslint-disable-next-line no-param-reassign
    el.placeholder = firstError;
  };

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const name = e.target.elements['ContactForm-name'].value || '';
    const email = e.target.elements['ContactForm-email'].value;
    const subject = e.target.elements['ContactForm-subject'].value || '';
    const body = e.target.elements['ContactForm-body'].value || '';

    const errors =
      validate(
        {
          subject,
          name,
          email,
          body,
        },
        constraints,
      ) || {};

    if (Object.keys(errors).length === 0) {
      const obj = {
        request: {
          requester: { name, email },
          subject,
          comment: { body },
        },
      };

      postData(webhookURL, obj)
        .then(() => {
          form.innerHTML = `<div>${success}</div>`; // eslint-disable-next-line no-console
        })
        .catch((err) => console.error(err));
    } else {
      if (errors.name)
        showError(e.target.elements['ContactForm-name'], errors.name);
      if (errors.subject)
        showError(e.target.elements['ContactForm-subject'], errors.subject);
      if (errors.email)
        showError(e.target.elements['ContactForm-email'], errors.email);
      if (errors.body)
        showError(e.target.elements['ContactForm-body'], errors.body);
    }
  });
};
